import react, { useState, useEffect } from "react";
import {Grid, Typography, Container, Button, Fab, Tooltip} from "@mui/material";
import { NumberOfUnitsControl } from "../components/NumUnitsControl";
import Api from "../services/Api";
import { OptimizationCard } from "../components/OptimizationCard";
import { useHistory } from "react-router-dom";
import useDocumentTitle from "../hooks/useDocumentTitle";
import SortIcon from '@mui/icons-material/Sort';
import { SortByTime } from "../utils/momentUtils";


export const OptimizationHome = (props) => {
  const [optimizations, setOptimizations] = useState([]);
  const [numUnits, setNumUnits] = useState(0);
  const [sortAsc, setSortAsc] = useState(false);
  const history = useHistory();
  useDocumentTitle("Schedules");

  useEffect(() => {
    getData();
  }, [])

  const getData = async () => {
    let opts = await Api.getAllCompleteOptimizationRequests();
    if (opts != null){
      setOptimizations(opts);
    }
  }

  const getOpts = () => {
    let toDisplay = null;
    if (numUnits === 0){
      toDisplay = optimizations.slice();
      // return optimizations;
    }else {
      toDisplay = optimizations.filter(x => x.dailyAssignments == numUnits);
    }
    toDisplay.sort((a, b) => SortByTime(a.dateRequested, b.dateRequested, sortAsc));
    return toDisplay;
  }

  const onCardClick = async (request) => {
    let fullOpt = await Api.getOptimizationRequestById(request.id);
    history.push("/optimization/view", {optimization: fullOpt});
  }


  return (
    <Container>
    <Grid container justifyContent={"center"} spacing={1} sx={{paddingTop: "1em", paddingBottom:"2em"}}>
      <Grid item xs={10}>
        <Typography variant="h5">
          Recommended Schedules
        </Typography>
      </Grid>
      <Grid item xs={2}>
          <NumberOfUnitsControl value={numUnits} setValue={(e) => setNumUnits(e.target.value)} />
      </Grid>
      {getOpts().map(x => 
        <Grid item xs={8} key={x.id}>
          <OptimizationCard data={x} onClick={onCardClick}/>
        </Grid>
      )}
    </Grid>
    <Tooltip title={`Sort by ${sortAsc ? "Newest" : "Oldest"}`}>
      <Fab sx={{position: 'fixed', right: '10%', bottom: '5%'}} color="primary"
        onClick={() => setSortAsc(!sortAsc)}
      >
        <SortIcon sx={{rotate: 180}}/>
      </Fab>
    </Tooltip>
    </Container>
  )

}

export default OptimizationHome;